import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import { useSelector } from "react-redux";

import "./raised-query.scss";
import Header from "../../components/header/header";
import QueryCard from "../../components/query-card/query-card";
import Loader from "../../components/loader/loader";
import GetQueriesAPI from "../../services/GetQueries/GetQueries";
import {pageUrl} from "../../utils/pageConstant";
import { Tabs, colors } from "@mui/material";

const RaisedQuery = () => {
  const navigate = useNavigate();
  const [value, setValue] = useState("1");
  const [queryList, setQueryList] = useState();
  const [isLoader, setIsLoader] = useState(true);
  const walletReward = useSelector((state) => state.wallet.coins);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    console.log("newValue", newValue);
  };

  const handleBack = () => {
    navigate(pageUrl.HELP);
  };

  useEffect(() => {
    getQueryList();
  }, []);

  const getQueryList = async () => {
    try {
      const responseData = await GetQueriesAPI();
      setQueryList(responseData);
      setIsLoader(false);
    } catch (error) {
      console.log("queryList---", error);
    }
  };
  return (
    <div className="query-page">
      {isLoader && <Loader />}
      <Header coin={walletReward} onClick={handleBack} label="Raised Query" />
      <div className="query-content">
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList onChange={handleChange} aria-label="Raised Query Tab" indicatorColor="blue">
              <Tab label="Active Tickets" value="1" />
              <Tab label="Closed Tickets" value="2" />
            </TabList>
          </Box>
          <div>
            <TabPanel value="1">
              {queryList?.map((query) => {
                return (
                  <>
                    {query.status === "Active" && (
                      <QueryCard
                        title={query.summary ? query.summary: ''}
                        ticket={query.supportKey ? query.supportKey : ''} //query.supportKey.split('-')[1]
                        date={query.createdDate ? query.createdDate: ''}
                        status={query.status ? query.status: ''}
                      />
                    )}
                  </>
                );
              })}
            </TabPanel>
            <TabPanel value="2">
              {queryList?.map((query) => {
                return (
                  <>
                    {query.status !== "Active" && (
                      <QueryCard
                        title={query.summary ? query.summary: ''}
                        ticket={query.supportKey ? query.supportKey : ''}
                        date={query.createdDate ? query.createdDate: ''}
                        status={query.status ? query.status: ''}
                      />
                    )}
                  </>
                );
              })}
            </TabPanel>
          </div>
        </TabContext>
      </div>
    </div>
  );
};

export default RaisedQuery;
